var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 144,
    viewBox: "0 0 91 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15.6078 141V142.5H17.1078H38.2331H39.7331V141V3V1.5H38.2331H21.6618H20.9072L20.4574 2.1058C19.6922 3.13637 18.505 4.42434 16.8579 5.97851C15.205 7.42461 13.4255 8.8735 11.5188 10.325C9.59387 11.7903 7.79501 13.1426 6.12201 14.3821C4.44247 15.5134 3.12512 16.429 2.17835 17.1245L1.56641 17.574V18.3333V39.4593V42.2778L3.90426 40.7034C4.8791 40.047 5.93946 39.3874 7.08631 38.7249L8.96428 37.7132L10.8618 36.6909L10.8871 36.6773L10.9118 36.6627C12.2578 35.8696 13.5189 35.1336 14.6952 34.4547C15.0072 34.2746 15.3114 34.0941 15.6078 33.9131V141ZM64.7744 141V142.5H66.2744H87.3997H88.8997V141V3V1.5H87.3997H70.8284H70.0738L69.624 2.1058C68.8588 3.13638 67.6716 4.42437 66.0245 5.97855C64.3716 7.42463 62.5921 8.87351 60.6854 10.325L61.5939 11.5185L60.6854 10.325C58.7605 11.7903 56.9616 13.1426 55.2886 14.3821C53.6091 15.5134 52.2917 16.429 51.345 17.1245L50.733 17.574V18.3333V39.4593V42.2778L53.0709 40.7034C54.0457 40.047 55.1061 39.3873 56.253 38.7248L60.0284 36.6909L60.0537 36.6773L60.0784 36.6627C61.4245 35.8696 62.6855 35.1336 63.8618 34.4547C64.1738 34.2746 64.478 34.0941 64.7744 33.9131V141Z",
    stroke: "#757575",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg11);
export default __webpack_public_path__ + "static/media/11.cf60f50aed73e6c71a7af200c642c3dd.svg";
export { ForwardRef as ReactComponent };